import { Ability, AbilityBuilder } from "@casl/ability"
import store from "../redux/store"

// Defines how to detect object's type
function subjectName(item) {
  if (!item || typeof item === "string") {
    return item
  }
  return item.__type
}

const ability = new Ability([], { subjectName })

let currentAuth
store.subscribe(() => {
  const prevAuth = currentAuth
  currentAuth = store.getState().auth
  if (prevAuth !== currentAuth) {
    ability.update(defineRulesFor(currentAuth))
  }
})

function defineRulesFor(auth) {
  const { can, rules } = new AbilityBuilder(ability);

  // const { can, rules } = AbilityBuilder.extract()
  // if (auth.role === "researcher") {
  //   can("view", "Proposal")
  //   can("view", "Draft")
  //   can("apply", "Proposal")
  //   can("view", "Profile")
  //   can("view", "Teams")
  // }

  if (auth.role === "Clerk" || auth.role === "CHD" || auth.role === "DD's & AD's") {
    let permissions = auth.user.permission;


    // for clerk users ..

    let clerkPermissionTab = permissions && permissions
      .filter(permission => permission.clerkPermission)
      .map((permission, index) => {
        return permission.clerkPermission;
      })

    // console.log("clerkPermission", clerkPermissionTab)

    let allProcessPermission = clerkPermissionTab.length && clerkPermissionTab.map((v, i) => {
      can('clerkPermission', v);
    })


    // for chd users ..

    let CHDPermissionTab = permissions && permissions
      .filter(permission => permission.CHDPermission)
      .map((permission, index) => {
        return permission.CHDPermission;
      })

    // console.log("CHDPermission", CHDPermissionTab)

    let CHDPermission = CHDPermissionTab.length && CHDPermissionTab.map((v, i) => {
      can('CHDPermission', v);
    })

    // for Ads users ...

    let DDsAndADPermissionTab = permissions && permissions
      .filter(permission => permission.DDsAndADPermission)
      .map((permission, index) => {

        return permission.DDsAndADPermission;
      })

    // console.log("DDsAndADPermission", DDsAndADPermissionTab)

    let DDsAndADPermission = DDsAndADPermissionTab.length && DDsAndADPermissionTab.map((v, i) => {
      can('DDsAndADPermission', v);
    })

  }

  if (auth.role === "admin" || auth.role === "subAdmin") {
    //   console.log('auth ability')
    // console.log(auth)
    let permissions = auth.user.permission;
    // console.log('permissions')
    // console.log(auth)
    if (permissions) {
      let dashboardTab = permissions && permissions
        .filter(permission => permission.dashboardTab)
        .map((permission, index) => {
          return permission.dashboardTab;
        })
      // console.log('dashboardTab')
      // console.log(dashboardTab)
      let allPermissions = dashboardTab.length && dashboardTab.map((v, i) => {
        can('dashboardTab', v);
      })

      //All process permissions..

      let allProcessTab = permissions && permissions
        .filter(permission => permission.allProcessTab)
        .map((permission, index) => {
          return permission.allProcessTab;
        })

      let allProcessPermission = allProcessTab.length && allProcessTab.map((v, i) => {
        can('allProcessTab', v);
      })

      //Department permissions..

      // let departmentTab =permissions && permissions
      // .filter(permission => permission.departmentTab )
      // .map((permission, index) => {
      //   return permission.departmentTab;
      // })

      // let allDepartmentPermission = departmentTab.length && departmentTab.map((v,i) => {
      //   can('departmentTab', v);
      // })

      //Department permissions..

      //Branch
      let manageB = permissions && permissions
        .filter(permission => permission.manageB)
        .map((permission, index) => {
          return permission.manageB;
        })
      // console.log('manageB1==> ', manageB);
      let manageBranchPermission = manageB.length && manageB.map((v, i) => {
        can('manageB', v);
        // console.log('manageB==> ', v);
      })

      //manageIo
      let manageIo = permissions && permissions
        .filter(permission => permission.manageIo)
        .map((permission, index) => {
          return permission.manageIo;
        })

      let manageIoPermission = manageIo.length && manageIo.map((v, i) => {
        can('manageIo', v);
      })

      //manageId
      let manageId = permissions && permissions
        .filter(permission => permission.manageId)
        .map((permission, index) => {
          return permission.manageId;
        })

      let manageIdPermission = manageId.length && manageId.map((v, i) => {
        can('manageId', v);
      })

      //UserRoles permissions..

      let userRolesTab = permissions && permissions
        .filter(permission => permission.userRolesTab)
        .map((permission, index) => {
          return permission.userRolesTab;
        })

      let allUserRolesPermission = userRolesTab.length && userRolesTab.map((v, i) => {
        can('userRolesTab', v);
      })

      //ManageUsers permissions..

      let manageUsersTab = permissions && permissions
        .filter(permission => permission.manageUsersTab)
        .map((permission, index) => {
          return permission.manageUsersTab;
        })

      let allManageUsersPermission = manageUsersTab.length && manageUsersTab.map((v, i) => {
        can('manageUsersTab', v);
      })
    }

    // can("dashboardTab", "viewOnly")
    //  can("view", "Proposal")
    //  can("accept", "Application")
    //  can("reject", "Application")
    //  can("view", "PendingReviews")
  }
  if (auth.role === "reviewer") {
    can("review", "Proposal")
  }
  return rules
}

export default ability